import * as componentActions from '@catdetails/actions/speaker-setup';
import {ActionItemState} from '@catdetails/types';
import {Action} from '@ngrx/store';

export const initialState: ActionItemState = {
  isActive: false,
};

export function reducer(state: ActionItemState = initialState, action: Action) {

  let returnable = state;

  switch (action.type) {
    case componentActions.PROJECT_SPEAKER_SETUP_ACTIVATE:
      returnable = {...state, isActive: true};
      break;
    case componentActions.PROJECT_SPEAKER_SETUP_DEACTIVATE:
      returnable = {...state, isActive: false};
      break;
  }

  return returnable;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/reducers/speaker-setup.reducer.ts